import React from 'react'
import { connect } from 'react-redux'
import { setTransDate, setEndDate, setPNodeZoneList } from 'core/actions'
import {
  getLoadingInitDataStatus,
  getLoadingDateDataStatus,
  getApiTargetInfo,
  getUnits,
  getUnitNameMap,
  getPnodeZoneEffective,
  getUserName,
  getClientInfo,
  getEndDate,
} from 'core/selectors'
import { loadDataForDate } from '../core/actions'

const DatePickerContextReducer = ({
  children,
  // transDate,
  setDate,
  endDate,
  setEndDate,
  initLoadingDataStatus,
  unitLoadingStatus,
  targetInfo,
  units,
  unitNameMap,
  setPNodeZoneList,
  pnodeZoneList,
  userName,
  CLIENT,
  loadDateData,
}) => {
  return children({
    // transDate,
    setDate,
    endDate,
    setEndDate,
    initLoadingDataStatus,
    unitLoadingStatus,
    targetInfo,
    units,
    unitNameMap,
    setPNodeZoneList,
    pnodeZoneList,
    userName,
    CLIENT,
    loadDateData,
  })
}

const mapStateToProps = state => ({
  initLoadingDataStatus: getLoadingInitDataStatus(state),
  unitLoadingStatus: getLoadingDateDataStatus(state),
  targetInfo: getApiTargetInfo(state),
  units: getUnits(state),
  unitNameMap: getUnitNameMap(state),
  pnodeZoneList: getPnodeZoneEffective(state),
  userName: getUserName(state),
  CLIENT: getClientInfo(state),
  // transDate: getTransDate(state),
  endDate: getEndDate(state),
})

// eslint-disable-next-line no-unused-vars
export default connect(mapStateToProps, dispatch => ({
  setDate: setTransDate,
  setEndDate,
  setPNodeZoneList,
  loadDateData: (date, edate, withRetriedUnits) => {
    dispatch((thunk, state) =>
      loadDataForDate(date, edate, withRetriedUnits)(thunk, state)
    )
  },
}))(DatePickerContextReducer)
